import { EnterExitHourlyRecord } from '../EnterExitHourlyRecord'
import { Common } from '@/core/Common';
import { DataType } from '../../DataType';
import { FView } from '@/core/FView';
//import moment from 'moment';

export class EnterExitHourlyFormattedRecord extends EnterExitHourlyRecord {

    public get colorClass(): string {
        if (!this.isworkingtime) {
            return Common.GetOffHourTimeClass();
        }
        return "";
    }

    public static getAllDates() {
        let dataSet = FView.Get().dataManager.GetDataset<EnterExitHourlyRecord>(DataType.EnterExitHourly);
        return dataSet.flatMap(r => r.stat_date).filter((v, i, a) => a.indexOf(v) === i);
    }

    public static getAllPlaces() {
        let dataSet = FView.Get().dataManager.GetDataset<EnterExitHourlyRecord>(DataType.EnterExitHourly);
        let places = dataSet.flatMap(r => r.address).filter((v, i, a) => a.indexOf(v) === i).sort();
        return places;
    }

    public static getAllHours() {
        let dataSet = FView.Get().dataManager.GetDataset<EnterExitHourlyRecord>(DataType.EnterExitHourly);
        return dataSet.flatMap(r => r.time).filter((v, i, a) => a.indexOf(v) === i).sort();
    }

    public static getWorkingHours() {
        let dataSet = FView.Get().dataManager.GetDataset<EnterExitHourlyRecord>(DataType.EnterExitHourly);
        return dataSet.filter(r => r.isworkingtime).flatMap(r => r.time).filter((v, i, a) => a.indexOf(v) === i).sort();
    }



    public static getRecords() {
        let dataSet = FView.Get().dataManager.GetDataset<EnterExitHourlyRecord>(DataType.EnterExitHourly);
        let result:Record<string, Record<string, Record<string, EnterExitHourlyFormattedRecord>>> = {};

        let allDates = this.getAllDates();
        let allHours = this.getAllHours();
        let allPlaces = this.getAllPlaces();
        let workingHours = this.getWorkingHours();

        for (let date of allDates) {
            result[date] = {}
            for (let time of allHours) {
                result[date][time] = {};
                for (let place of allPlaces) {
                    let record = this.findRecord(dataSet, date, place, time);
                    let computedRecord: EnterExitHourlyFormattedRecord;
                    if (record != null) {
                        computedRecord = Object.assign<EnterExitHourlyFormattedRecord, EnterExitHourlyRecord>(new EnterExitHourlyFormattedRecord(), record);
                    } else {
                        computedRecord = new EnterExitHourlyFormattedRecord();
                        computedRecord.isworkingtime = workingHours.includes(time);
                    }
                    result[date][time][place] = computedRecord;
                }
            }
        }

       return result;
    }

    private static findRecord(dataSet:EnterExitHourlyRecord[], date:string, place:string, time: string) {
        return dataSet.find(r => r.stat_date == date && r.address == place && r.time == time);
    }
}
